import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

export function onlyChar(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value == '') return null;
    const re = new RegExp('^[a-zA-Z ]*$');
    if (re.test(control.value)) {
      return null;
    }
    return { onlyChar: true };
  };
}
export function passwordMismatch(password: string, confirmPassword: string) {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const passwordControl = formGroup.get(password);
    const confirmPasswordControl = formGroup.get(confirmPassword);

    if (!passwordControl || !confirmPasswordControl) {
      return null;
    }

    if (
      confirmPasswordControl.errors &&
      !confirmPasswordControl.errors['passwordMismatch']
    ) {
      return null;
    }

    if (passwordControl.value !== confirmPasswordControl.value) {
      confirmPasswordControl.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    }
    confirmPasswordControl.setErrors(null);
    return null;
  };
}
export function passwordStrength(
  control: AbstractControl
): ValidationErrors | null {
  const value: string = control.value || '';

  if (!value) {
    return null;
  }
  const strongRegex = new RegExp(
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{12,})'
  );
  if (strongRegex.test(value) === false) {
    return {
      passwordStrength:
        'Password must contain at least one upper case,lower case, number and 12 characters long',
    };
  }

  return null;
}

export function onlyNumric(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value == '') return null;
    const re = new RegExp('^[0-9]*$');
    if (re.test(control.value)) {
      return null;
    }
    return { onlyNumric: true };
  };
}

export function checkEmailMobile(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value == '') return null;
    const re = new RegExp('^[0-9]*$');
    if (re.test(control.value)) {
      const isPhoneRegexp = new RegExp('^[0-9]{10}$');
      if (isPhoneRegexp.test(control.value)) {
        return null;
      }
      return { isPhoneCheck: true };
    }
    const isEmailRegexp = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    if (isEmailRegexp.test(control.value)) {
      return null;
    }
    return { isEmailCheck: true };
  };
}
export function decimalNumeric(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value == '') return null;
    // let re = new RegExp(/^-?\d*[.,]?\d{0,2}$/);
    const re = new RegExp(/^\d+(\.\d{1,2})?$/);
    if (re.test(control.value)) {
      return null;
    }
    return { decimalNumeric: true };
  };
}

export function moveItemInFormArray(
  formArray: FormArray,
  fromIndex: number,
  toIndex: number
): void {
  const dir = toIndex > fromIndex ? 1 : -1;
  const item = formArray.at(fromIndex);
  for (let i = fromIndex; i * dir < toIndex * dir; i += dir) {
    const current = formArray.at(i + dir);
    formArray.setControl(i, current);
  }
  formArray.setControl(toIndex, item);
}
export function checkEmail(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value == '') return null;
    const isEmailRegexp = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    if (isEmailRegexp.test(control.value)) {
      return null;
    }
    return { isEmailCheck: true };
  };
}

export function checkMobile(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value == '') return null;

    const isPhoneRegexp1 = new RegExp('^[0-9]{10,13}$');
    // let isPhoneRegexp2=new RegExp('^[0-9]{13}$');
    if (isPhoneRegexp1.test(control.value)) {
      return null;
    }
    return { isPhoneCheck: true };
  };
}
/**
 * Angular only re-runs a control's validators when that control's value changes, so whatever the
 * condition depends on has to trigger `updateValueAndValidity()` on the control itself.
 */
export function requiredIf(condition: () => boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null =>
    condition() ? Validators.required(control) : null;
}

/**
 * A PDF, judged on the type the browser declared and, when it declared none,
 * on the name. Client-side only: it spares an upload that would be refused,
 * and the server decides for real by opening the file.
 */
export function pdfFile(control: AbstractControl): ValidationErrors | null {
  const file = control.value as File | null;
  if (!file) return null;
  const isPdf =
    file.type === 'application/pdf' ||
    (!file.type && /\.pdf$/i.test(file.name));
  return isPdf ? null : { pdf: true };
}

export function sanitizeString(inputString: string): string {
  const sanitizedString = inputString.replace(/[^A-Za-z0-9\s]/g, '');
  return sanitizedString;
}
